<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Documentação Necessária';    
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>    
	<div class="container">
		<p>Confira as documentações solicitadas para locação:</p>
		<div class="box-itens-icon mb-20">
			<div class="item">
				<div class="icon maxw-200">
					<i class="fas fa-user"></i>
				</div>
				<div class="infos">
					<h2 class="title color-primary">Locatário Pessoa Física</h2>
					<ul class="list-cycle">
						<li>Fotocópia do documento de identidade e CPF;</li>
						<li>Fotocópia do comprovante de renda e declaração do imposto de renda;</li>
						<li>Caso seja casado torna-se necessário encaminhar fotocópias da mesma documentação do cônjuge e também fotocópia da certidão de casamento.</li>
						<li><b>OBSERVAÇÃO:</b> A renda a ser comprovada deverá ser superior a três vezes o valor do aluguel e encargos, podendo ser somada a renda do cônjuge.</li>
					</ul>
					<a class="btn btn-primary icon-transform mt-20" href="/fichas-cadastrais" use:link title="Clique aqui para fazer o download da ficha cadastral">
						Download Ficha Cadastral  <i class="fas fa-download ml-10"></i> 
					</a>
				</div>
			</div>
			<div class="item">
				<div class="icon maxw-200">
					<i class="fas fa-user-tie"></i>
				</div>
				<div class="infos">
					<h2 class="title color-primary">Locatário Pessoa Jurídica</h2>
					<ul class="list-cycle">
						<li>Fotocópia do contrato social com todas as alterações ou, se for o caso, fotocópia do estatuto e ata da última assembléia;</li>
						<li>Fotocópia do último balanço geral e do último balancete;</li>
						<li>Fotocópia do CNPJ e Inscrição Estadual;</li>
						<li>Fotocópia da carteira de identidade e CPF do sócio que representará a empresa.</li>
					</ul>
					<a class="btn btn-primary icon-transform mt-20" href="/fichas-cadastrais" use:link title="Clique aqui para fazer o download da ficha cadastral">
						Download Ficha Cadastral  <i class="fas fa-download ml-10"></i> 
					</a>
				</div>
			</div>
			<div class="item">
				<div class="icon maxw-200">
					<i class="fas fa-user"></i>
				</div>
				<div class="infos">
					<h2 class="title color-primary">Fiadores</h2>
					<ul class="list-cycle">
						<li>Fotocópia do documento de identidade e CPF;</li>
						<li>Fotocópia do comprovante de renda e declaração do imposto de renda;</li>
						<li>Caso seja casado torna-se necessário encaminhar fotocópias da mesma documentação do cônjuge e também fotocópia da certidão de casamento;</li>
						<li>Fotocópia de comprovante de residência;</li>
						<li>Certidão atualizada de dois Registros de Imóveis localizados no RS (não podendo possuir nenhum tipo de ônus).</li>
						<li><b>OBSERVAÇÃO:</b> A renda a ser comprovada deverá ser superior a três vezes o valor do aluguel e encargos, podendo ser somada a renda do cônjuge;</li>
					</ul>
					<a class="btn btn-primary icon-transform mt-20" href="/fichas-cadastrais" use:link title="Clique aqui para fazer o download da ficha cadastral">
						Download Ficha Cadastral  <i class="fas fa-download ml-10"></i> 
					</a>
				</div>
			</div>
		</div>
		<hr />
		<h2 class="title color-primary">Outras Garantias Locatícias</h2>
		<ul class="list-cycle">
			<li>Se você não possui Fiadores, aceitamos também outros tipos de Garantias Locatícias - <a href="/garantias-locaticias" use:link>Veja Aqui</a></li>
		</ul>
		<br />
		<h2 class="title color-primary">Observação</h2>
		<ul class="list-cycle">
			<li>Os pretendentes a locação (locatários e fiadores) não podem ter restrições em empresas e/ou entidades de análise de crédito como “SPC e SERASA";</li>
			<li>O interessado somente terá preferência do imóvel após apresentar toda a documentação solicitada.</li>
			<li>Eventualmente poderão ser solicitados outros documentos para confirmação dos dados apresentados.</li>
		</ul>
		<br />
		<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
		<div class="button text-center mt-40">
			<a href="/garantias-locaticias" use:link replace title="Confira as garantias locatícias" class="btn btn-secondary">Confira as garantias locatícias <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> </a>
		</div>
	</div>

</section>